import { defineStore } from 'pinia'
import { ref } from 'vue'
import triplaLocalStorage from 'Utilities/triplaLocalStorage'

export const useTermsConditionsStore = defineStore('TermsConditions', () => {
  const show = ref(false)
  const accepted = ref(triplaLocalStorage.getItem('terms_conditions_accepted') === 'true')
  const settings = ref({
    active: true,
    title: '',
    body: '',
    accepted: false
  })

  function setShow(value) {
    show.value = value
  }

  function setAccepted(value) {
    accepted.value = value
  }

  function setSettings(value) {
    settings.value = value
  }

  return { show, accepted, settings, setShow, setAccepted, setSettings }
})
